export default __webpack_public_path__ + "static/media/Mission-Control-Empty.1aab0f2d.png";